<template lang="pug">
div
  h1 GDPR Policy

  h2 Does PandaFan comply with GDPR?
  p Yes, as a European company, PandaFan implements a comprehensive privacy and information security program to comply with GDPR.

  h2 What data do we collect?
  p See 
    a(href='/privacy-policy') Privacy Policy
    | .

  h2 How will we use your data?
  p See 
    a(href='/privacy-policy') Privacy Policy
    | .

  h2 How do we store your data?
  p See 
    a(href='/privacy-policy') Privacy Policy
    | .

  h2 How can I request for my data to be updated or deleted?
  p If you have a PandaFan account, simply log in to create a Support Ticket for your request.
    br
    | If you have any further questions, feel free to contact us at pandafan-gdpr@beexio.com to get assistance from our team.

  h2 What are your data protection rights?
  p Our Company would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:

  p 
    b The right to access
    | : You have the right to request Our Company for copies of your personal data. We may charge you a small fee for this service.

  p 
    b The right to rectification
    | : You have the right to request that Our Company correct any information you believe is inaccurate. You also have the right to request Our Company to complete the information you believe is incomplete.

  p 
    b The right to erasure
    | : You have the right to request that Our Company erase your personal data, under certain conditions.

  p 
    b The right to restrict processing
    | : You have the right to request that Our Company restrict the processing of your personal data, under certain conditions.

  p 
    b The right to object to processing
    | : You have the right to object to Our Company's processing of your personal data, under certain conditions.

  p 
    b The right to data portability
    | : You have the right to request that Our Company transfer the data that we have collected to another organization, or directly to you, under certain conditions.

  p If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us at our email: pandafan-gdpr@beexio.com

  h2 Changes to the GDPR Policy
  p We may update this policy from time to time. Please regularly check this policy to ensure you are aware of the most updated version.
</template>
